import React, {} from 'react';

import * as deviceAccessStatuses from 'constants/device-access-statuses';

import SimpleDialog from 'generics/components/simple-dialog';

import './index.scss';

function DeviceAccessStatusDisplay(props) {

  function renderMicrophoneAndCameraAccessNeededInformation() {

    return <div className="device-access-status-display-content">

      <h3 className="device-access-status-display-header">Microphone and camera are disallowed/blocked!</h3>

      <p className="device-access-status-display-body">
        HelpTap live streaming requires access to your microphone and camera. Click the lock icon in your browser’s address bar to allow/unblock access.
      </p>

    </div>;

  }

  function renderMicrophoneAccessNeededInformation() {

    return <div className="device-access-status-display-content">

      <h3 className="device-access-status-display-header">Microphone is disallowed/blocked!</h3>

      <p className="device-access-status-display-body">
        HelpTap live streaming requires access to your microphone. Click the lock icon in your browser’s address bar to allow/unblock access.
      </p>

    </div>;

  }

  function renderCameraAccessNeededInformation() {

    return <div className="device-access-status-display-content">

      <h3 className="device-access-status-display-header">Camera is disallowed/blocked!</h3>

      <p className="device-access-status-display-body">
        HelpTap live streaming requires access to your camera. Click the lock icon in your browser’s address bar to allow/unblock access.
      </p>

    </div>;

  }

  function renderStatus() {

    if (props.microphoneAccessStatus !== deviceAccessStatuses.ALLOWED && props.cameraAccessStatus !== deviceAccessStatuses.ALLOWED) {

      return renderMicrophoneAndCameraAccessNeededInformation();

    } else if (props.microphoneAccessStatus !== deviceAccessStatuses.ALLOWED) {

      return renderMicrophoneAccessNeededInformation();

    }

    return renderCameraAccessNeededInformation();

  }

  function renderDismissButton() {

    const buttonAttributes = {
      className: 'delete-button dialog-dismiss-button',
      onClick() {
        props.onClose();
      }
    };

    return <div className="dialog-dismiss-button-container">
      <button {...buttonAttributes}>Dismiss</button>
    </div>;

  }

  function renderMain() {

    const dialogProperties = {
      stackTopClass: 'async-dialog',
      contentHolderClassName: 'device-access-status-display-dialog-holder',
      onClose() {
        props.onClose();
      }
    };

    return <SimpleDialog {...dialogProperties}>
      <div id="device-access-status-display-main">
        {renderStatus()}
        {renderDismissButton()}
      </div>
    </SimpleDialog>;

  }

  return renderMain();

}

export default DeviceAccessStatusDisplay;